export default __webpack_public_path__ + "static/media/Points-box.9fb80cd1.png";